import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

export interface TableColumn {
  name: string;
  dataKey: string;
  isActionColumn?: boolean;
  dataType?: string;
  position?: 'right' | 'left';
  embolden?: boolean;
  isMoney?: boolean;
  isDishes?: boolean;
  actionType?: 'button' | 'image';
  actionLabel?: string;
}

@Component({
  selector: 'app-base-table',
  templateUrl: './base-table.component.html',
  styleUrls: ['./base-table.component.scss'],
})
export class BaseTableComponent implements OnInit {
  @Output() emitSelectedRowItem = new EventEmitter<any>();
  @Output() emitActionClick = new EventEmitter<{action: string, item: any}>();
  @Input() tableColumns: any[] = [];
  @Input() set tableData(data: any[]) {
    this.setTableDataSource(data);
  }

  tableDataSource: any = new MatTableDataSource([]);
  displayedColumns!: string[];

  constructor() {}

  ngOnInit(): void {
    const columnNames = this.tableColumns.map(
      (tableColumn: TableColumn) => tableColumn.name
    );
    this.displayedColumns = columnNames;
  }

  setTableDataSource(data: any[]) {
    this.tableDataSource = new MatTableDataSource(data);
  }

  handleRowClick(tableItem: any) {
    this.emitSelectedRowItem.emit(tableItem);
  }

  handleActionClick(action: string, item: any, event: Event) {
    event.stopPropagation();
    this.emitActionClick.emit({ action, item });
  }

  toString(value: any) {
    return value && value !== null ? String(value) : value;
  }

  joinArrayItems(items: any[]) {
    return items.join(', ');
  }
}
